var React = require('react');

function SpeakerUrlLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#2D64BC","d":"M2 3.68117C2 2.75308 2.75308 2 3.68117 2c.9275 0 1.68058.75308 1.68116 1.68117 0 .92808-.75308 1.69691-1.68116 1.69691C2.75308 5.37808 2 4.60925 2 3.68117Z","key":0}),React.createElement("path",{"fill":"#2D64BC","d":"M16.0012 15.9992v-5.1345c0-2.51181-.5407-4.44673-3.4772-4.44673-1.4117 0-2.359.77467-2.74579 1.50908h-.04083V6.65247H6.95312v9.34673h2.89917v-4.6281c0-1.2186.23101-2.39696 1.74011-2.39696 1.4869 0 1.5091 1.39066 1.5091 2.47506v4.5506l2.8997-.0006Z","key":1}),React.createElement("path",{"fill":"#2D64BC","d":"M2.23047 6.65332h2.90267v9.34678H2.23047V6.65332Z","key":2})]);
}

SpeakerUrlLinkedin.defaultProps = {"fill":"none","viewBox":"0 0 18 18"};

module.exports = SpeakerUrlLinkedin;

SpeakerUrlLinkedin.default = SpeakerUrlLinkedin;
